import React, { useContext, useMemo, useEffect, useState, useCallback } from 'react';
import { projRoleFields } from './formFields';
import { useForm } from 'react-hook-form';
// import {
//   rFetchProjList,
//   rFetchRoleList,
//   rFetchUserProjsRoles,
//   getStoredUserProjsRoles,
//   getStoredRoleList,
//   getStoredProjList,
//   setState
// } from 'store/reducers/authentication';
import useMain from 'hooks/useMain';
import CusFormField from 'components/CusFormField';
import MainCard from 'components/MainCard';
import { Box, Button, CardContent, CardHeader } from '@mui/material';
import { userAdminService } from 'services/userAdmin';
import { rFetchProjectList, rFetchRoleList, setState } from 'store/reducers/comModule';
import { mapListToOptions } from 'utils/common';
import { Button2 } from 'components/Button';

export const ProjRoleSelector = ({ userId, setOpenModal }) => {
  const { t, dispatch, useSelector } = useMain();
  const roles = useSelector((s) => s.comModule.roles);
  const projects = useSelector((s) => s.comModule.projects);
  const userProjsRoles = useSelector((s) => s.comModule.userProjsRoles);
  const roleOptions = mapListToOptions(roles, 'Value', 'Key');
  const projOptions = mapListToOptions(projects, 'ProjName', 'ProjId', 'ContractNo');

  const onSubmit = useCallback(
    (data) => {
      const { Project, UserRole } = data;
      const _userProjRoles = [...userProjsRoles];

      if (!_.isEmpty(projOptions)) {
        for (const proj of Project) {
          for (const ur of UserRole) {
            if (!userProjsRoles.find(({ Project, UserRoleId }) => proj === Project && UserRoleId === ur)) {
              _userProjRoles.push({
                ProjId: proj,
                UserId: userId,
                RoleId: ur,
                // ContractNo: projOptions.find(({ value }) => value === proj)?.ContractNo,
                Permission: `${projOptions.find(({ value }) => value === proj)?.label} ${
                  roleOptions.find(({ value }) => value === ur)?.label
                }`
              });
            }
          }
        }
      }

      dispatch(setState(['userProjsRoles', _userProjRoles]));
      setOpenModal(false);
    },
    [userId, projOptions]
  );

  useEffect(() => {
    if (_.isEmpty(projects)) {
      dispatch(rFetchProjectList());
    }
    if (_.isEmpty(roles)) {
      dispatch(rFetchRoleList());
    }
  }, [projects, roles]);

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors }
  } = useForm({
    UserRole: [],
    Project: []
  });

  return (
    <MainCard>
      <CardHeader title={t('PROJECT')} />
      <CardContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          {projRoleFields({
            t,
            roleOptions,
            projOptions,
            userProjsRoles,
            getValues
          }).map((props) => (
            <Box key={`user-admin-proj-role-form-${props.id}`} mb={2}>
              <CusFormField
                {...props}
                colProps={{
                  md: 12
                }}
                control={control}
              />
            </Box>
          ))}
          <Button2 text={t('IMPORT')} type="submit" color="primary" />
        </form>
      </CardContent>
    </MainCard>
  );
};
